module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach2",
      "title": "Stovetop Aquafaba"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch2"
    }
  }, [_vm._v("Stovetop Aquafaba")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("Homemade aquafaba is as easy as can be, and it’s significantly cheaper than using canned juice. It does, however, require at least one night (or a very full day) to soak the dried chickpeas, which is entirely inactive time but still must be accounted for. This recipe can easily be doubled.")])]), _vm._v(" "), _c('p', {
    staticClass: "recl"
  }, [_vm._v("2 cups (1 pound) dried chickpeas, rinsed well")]), _vm._v(" "), _c('p', {
    staticClass: "recl"
  }, [_vm._v("5 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "reclb"
  }, [_vm._v("pinch kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Place the rinsed chickpeas into a large container fitted with a lid. Cover the chickpeas with the water and seal the container. Allow the chickpeas to soak for 12 hours. Save the soaking water!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Move the chickpeas and soaking water into a small pot. Add the salt and more water if there is not enough to cover the beans. Turn the heat up to medium high and bring the contents of the pot to a boil. Reduce the heat until the peas and water are at a simmer, and allow to cook until the chickpeas are tender, anywhere between 45 minutes to an hour, depending on your chickpeas. If at any point during this process the water level gets too low and does not cover the beans, add just enough water until they are covered.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Drain the cooking liquid into a heat-proof vessel, like a jar. Allow the mixture to cool in the fridge. At this point it should be thicker and nice and viscous, exactly as it looks when it comes out of a can. If it is still water-thin, place the aquafaba back into a small pot and simmer to reduce by 10 to 20 percent more, or until the liquid has thickened. It will thicken up as it cools.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Note: Remember the aquafaba is always thinner when it is hot! Use only cool or room-temperature AF. Excess aquafaba can be frozen in ice cube trays for future use.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD:")]), _vm._v(" approximately 3 cups aquafaba, plus 7 cups cooked chickpeas"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PREP TIME:")]), _vm._v(" 10 minutes, plus 12 hour soak time"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("COOK TIME:")]), _vm._v(" 1 hour, plus overnight cooling")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4531cac2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter002.vue
// module id = 78
// module chunks = 0